import { ListChecks } from "lucide-react";
import { useGetIdentity, useGetList, useTranslate } from "ra-core";

import type { Task as TData } from "../types";
import { Task } from "../tasks/Task";
import { DashboardWidget } from "./DashboardWidget";

export const DashboardActionItems = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const { data, isPending } = useGetList<TData>(
    "tasks",
    {
      pagination: { page: 1, perPage: 50 },
      sort: { field: "due_date", order: "ASC" },
      filter: { "done_date@is": null, sales_id: identity?.id },
    },
    { enabled: !!identity },
  );

  return (
    <DashboardWidget
      icon={<ListChecks className="text-muted-foreground w-6 h-6" />}
      title={translate("crm.dashboard.action_items", {
        _: "Tasks & Feedback",
      })}
      seeAllTo="/tasks"
    >
      {isPending ? null : !data?.length ? (
        <p className="text-sm text-muted-foreground">
          {translate("crm.dashboard.no_action_items", {
            _: "No open tasks.",
          })}
        </p>
      ) : (
        <div className="divide-y">
          {data.map((task) => (
            <div key={task.id} className="py-3 first:pt-0 last:pb-0">
              <Task task={task} />
            </div>
          ))}
        </div>
      )}
    </DashboardWidget>
  );
};
